import { render, staticRenderFns } from "./SubscriptionGroupOption.vue?vue&type=template&id=0566d930&scoped=true"
import script from "./SubscriptionGroupOption.vue?vue&type=script&lang=js"
export * from "./SubscriptionGroupOption.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionGroupOption.vue?vue&type=style&index=0&id=0566d930&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0566d930",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0566d930')) {
      api.createRecord('0566d930', component.options)
    } else {
      api.reload('0566d930', component.options)
    }
    module.hot.accept("./SubscriptionGroupOption.vue?vue&type=template&id=0566d930&scoped=true", function () {
      api.rerender('0566d930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TradeWatcher/SubscriptionGroupOption.vue"
export default component.exports